
<div class="flex relative w-full" 
    appClickOutside (clickOutside)="setMenuOpenState(false)"
>
    
    <form 
        [formGroup]="searchFormGroup"
        class="flex w-full" 
        
        >
    
        <app-input
            formControlName="searchInput"
            class="flex w-full"
            [id]="'autocomplete-search-box-input'"
            [placeholder]="'Search by keywords, committees, projects or publications'"
            [startIcon]="searchIcon"
            (focusin)="onSearchInputFocus()"
        ></app-input>
    </form>
    
    <div 
        #menu
        class="absolute z-20 mt-12 flex w-full
        max-h-dvh overflow-auto scrollbar
         text-base bg-white rounded-md shadow-xl ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
        [class.hidden]="!isMenuOpen || isOnGlobalSearchPage"
    >
        <app-search-result-list
            id="autocomplete-search-result-list" 
            class="flex w-full"
            [isOnGlobalSearchPage]="isOnGlobalSearchPage"
            [showPagination]="false"
            (onListItemSelected)="handleItemSelected($event)"
        ></app-search-result-list>

    </div>  
 
</div>
    

